import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var CompareConditionsSection = function CompareConditionsSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var image = CDN_LINK + "/assets/images/compare/greenCheckMark.png";
  var items = [{
    text: tShort("compare/condition1", {
      ns: "web_common"
    })
  }, {
    text: tShort("compare/condition2", {
      ns: "web_common"
    })
  }, {
    text: tShort("compare/condition3", {
      ns: "web_common"
    })
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "py-16 px-5 lg:px-20"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-3xl font-bold text-center text-primary mb-10"
  }, tShort("compare/conditions_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    className: "md:flex md:gap-6 max-w-6xl mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#F4F9FE] rounded-xl pt-10 pb-12 flex flex-col gap-12 md:hidden"
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "flex flex-col items-center text-center"
    }, /*#__PURE__*/React.createElement("img", {
      src: image,
      alt: item.text,
      className: "w-20 h-20 object-contain mb-4",
      height: 80,
      width: 80,
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "text-primary font-bold text-xl"
    }, item.text));
  })), items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "hidden md:flex flex-col items-center text-center bg-[#F4F9FE] p-10 rounded-xl w-full min-h-[208px]"
    }, /*#__PURE__*/React.createElement("img", {
      src: image,
      alt: item.text,
      className: "w-20 h-20 object-contain mb-4",
      height: 80,
      width: 80
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-primary font-bold text-xl"
    }, item.text));
  })));
};
export default CompareConditionsSection;